exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".skill-bar-wrapper {\n  height: 25px;\n  border-radius: 25px;\n  background-color: #3e4360;\n  width: 350px;\n  overflow: hidden; }\n\n.skill-bar-inner {\n  height: 100%;\n  background-color: #985E6D; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/BenLeech/portfolio-website/portfolio-website/src/app/components/common/skill-bar/skill-bar.component.scss
// module id = ../../../../../src/app/components/common/skill-bar/skill-bar.component.scss
// module chunks = 1